import React from 'react';
import dynamic from 'next/dynamic';
import { connect } from 'react-redux';

import StyledWishes from './wishes.style';

import WishesProvider from './contexts/wishesProvider';

import Introduction from './components/introduction/introduction';
import ActionBar from './components/actionBar/actionBar';
import Evaluation from './components/evaluation/evaluation';
import Instructions from './components/instructions/instructions';
import WishDialog from './components/wishDialog/wishDialog';
import Wish from './components/wish/wish';

const Globe = dynamic(() => import('./components/globe/globe'), {
  ssr: false
});

const Wishes = ({ defaultTheme = false }) => {
  return (
    <StyledWishes $defaultTheme={defaultTheme}>
      <Globe />
      <Wish />
      <Introduction />
      <ActionBar>
        <WishDialog />
        <Evaluation />
        <Instructions />
      </ActionBar>
    </StyledWishes>
  );
};

const mapStateToProps = state => ({
  defaultTheme: state.accessibility.defaultTheme
});

const WishesComponent = connect(mapStateToProps)(Wishes);

export default ({
  wishesApiKeys,
  introduction,
  wishes,
  categories,
  evaluationIntro,
  wishesFormHint
}) => (
  <WishesProvider
    wishesApiKeys={wishesApiKeys}
    introduction={introduction}
    wishes={wishes}
    categories={categories}
    evaluationIntro={evaluationIntro}
    wishesFormHint={wishesFormHint}
  >
    <WishesComponent />
  </WishesProvider>
);
